import { Component, Inject, Prop, Watch } from 'vue-property-decorator';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import { FiltroParticipacion } from '@/shared/model/filtro-participacion.model';
import { RolAutoridad } from '@/shared/model/enumerations/rol-autoridad.model';
import ParticipanteService from '@/components/participantes/participante.service';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import JhiDataUtils from '@/shared/data/data-utils.service';
import * as dateUtils from '@/shared/date/date-utils';
import { StatusCodes } from 'http-status-codes';
import { mixins } from 'vue-class-component';
import { MenuTiempoDedicacionClaustro, ParticipacionSnp } from '@/shared/model/snp/claustro.model';
import CatalogosSnp from '@/shared/model/snp/catalogos-snp.factory';
import { BvTableFieldArray } from 'bootstrap-vue';
import ClaustroAsociarAlumnos from '@/entities/snp/solicitud/posgrado/claustro/claustro-asociar-alumnos.vue';
import { HistoricoPersonasApi } from '@conacyt/historicopersonasms-client';
import { MODALIDAD_PROGRAMA_CLAVE_ESPECIALIDADES_MEDICAS } from '@/shared/model/snp/snp-constants';
import PermisosUsuarioSnp, { PantallaSnp } from '@/entities/snp/permisos/permisos-snp.factory';
import PermisosSnpMixin from '@/entities/snp/permisos/permisos-snp.mixin';
import dayjs from 'dayjs';

@Component({
  components: {
    'claustro-asociar-alumnos': ClaustroAsociarAlumnos,
  },
})
export default class ClaustroListadoComponent extends mixins(JhiDataUtils, ApeironComponent, PermisosSnpMixin) {
  @Inject('participanteService') private readonly participanteService: () => ParticipanteService;
  @Inject('historicoPersonasApi') private readonly historicoPersonasApi: () => HistoricoPersonasApi;

  @Prop({ required: true })
  public readonly solucion: Solucion;

  @Prop({ required: true })
  public readonly solicitud: Solicitud;

  @Prop({ required: true })
  public permisos: any;

  @Prop({ required: true })
  public formModel: any;

  @Prop({
    required: false,
    default: function () {
      return false;
    },
  })
  public readonly actualizarTabla: boolean;

  public filtroClaustro = '';
  public claustros: Array<ParticipacionSnp> = [];
  public registros = 0;
  public perPage = 25;
  public currentPage = 1;
  public readonly pageOptions: Array<number> = [5, 15, 25, 50, 100, 150];

  public mostrarModalDetalle = false;
  public mostrarModalEditar = false;
  public mostrarModalEliminar = false;

  public claustroSeleccionado: ParticipacionSnp = new ParticipacionSnp();
  public tiemposDedicacion: Array<MenuTiempoDedicacionClaustro> = [];
  public noSNIMessage = '';
  public fechaHoy = '';

  public permiteVerHistoricos = false;

  public readonly fieldsClaustro: BvTableFieldArray = [
    {
      key: 'participante.cvu',
      label: this.$t('apeironGwApp.claustroSnp.form.cvuDocente').toString(),
      class: 'text-left',
      thStyle: { width: '3rem' },
    },
    {
      key: 'participante',
      label: this.$t('apeironGwApp.claustroSnp.form.nombreDocente').toString(),
      class: 'text-left',
      thStyle: { width: '15rem' },
    },
    {
      key: 'profesorSnp.tiempoDedicacion.nombre',
      label: this.$t('apeironGwApp.claustroSnp.form.tiempoDedicacion').toString(),
      class: 'text-left',
      thStyle: { width: '15rem' },
    },
    {
      key: 'profesorSnp.claustroFechaIngreso',
      label: this.$t('apeironGwApp.claustroSnp.form.fechaIngreso').toString(),
      class: 'text-left',
      thStyle: { width: '8rem' },
      formatter: value => dateUtils.formatUtc(value),
    },
    {
      key: 'profesorSnp.claustroFechaBaja',
      label: this.$t('apeironGwApp.claustroSnp.form.fechaBaja').toString(),
      class: 'text-left',
      thStyle: { width: '8rem' },
      formatter: value => dateUtils.formatUtc(value),
    },
    {
      key: 'acciones',
      label: this.$t('apeironGwApp.claustroSnp.acciones.acciones').toString(),
      class: 'text-center btn-acciones',
      thStyle: { width: '10rem' },
    },
  ];

  public readonly fieldsAlumnosRelacionados = [
    {
      key: 'cvu',
      label: this.$t('apeironGwApp.claustroSnp.form.cvuAlumno'),
      class: 'text-left',
      thStyle: { width: '5rem' },
    },
    {
      key: 'nombre',
      label: this.$t('apeironGwApp.claustroSnp.form.nombreAlumno'),
      class: 'text-left',
      thStyle: { width: '12rem' },
    },
    {
      key: 'apellidoPaterno',
      label: this.$t('apeironGwApp.claustroSnp.form.apellidoPaterno'),
      class: 'text-left',
      thStyle: { width: '12rem' },
    },
    {
      key: 'apellidoMaterno',
      label: this.$t('apeironGwApp.claustroSnp.form.apellidoMaterno'),
      class: 'text-left',
      thStyle: { width: '12rem' },
    },
    {
      key: 'relacion.nombre',
      label: this.$t('apeironGwApp.claustroSnp.modal.relacion'),
      class: 'text-left',
      thStyle: { width: '12rem' },
    },
    {
      key: 'relacionActiva',
      label: this.$t('apeironGwApp.claustroSnp.modal.relacionActiva'),
      class: 'text-center',
      thStyle: { width: '5rem' },
    },
  ];

  public created() {
    this.obtenerRolSnp().then(res => {
      this.permiteVerHistoricos = PermisosUsuarioSnp.validarPermisos(PantallaSnp.HISTORICO_SOLICITUD_POSGRADO_PROFESORES, res.rol);
    });
  }

  public mounted(): void {
    this.iniciarComponente();
  }

  @Watch('actualizarTabla')
  private refrescarTabla(): void {
    this.iniciarComponente();
  }

  private iniciarComponente(): void {
    this.claustroSeleccionado = new ParticipacionSnp();
    this.fechaHoy = dateUtils.obtenerFechaHoyYYYYMMDD();

    this.mostrarModalDetalle = false;
    this.mostrarModalEditar = false;
    this.mostrarModalEliminar = false;

    this.tiemposDedicacion = [];
    CatalogosSnp.obtenerTiemposDedicacion(
      this.solicitud.programa?.cveModalidad === MODALIDAD_PROGRAMA_CLAVE_ESPECIALIDADES_MEDICAS
    ).forEach(it => {
      this.tiemposDedicacion.push({ value: it, text: it.nombre });
    });

    this.obtenerProfesores();
  }

  public mostrarModalEliminarClaustro(claustro: ParticipacionSnp): void {
    this.claustroSeleccionado = ParticipacionSnp.fromObject(claustro);
    this.mostrarModalEliminar = true;
  }

  public editarClaustro() {
    const today = dateUtils.formatter.format(new Date());
    if (this.claustroSeleccionado.profesorSnp?.claustroFechaBaja < this.claustroSeleccionado.profesorSnp?.claustroFechaIngreso) {
      this.alertService().showError(this, this.$t('apeironGwApp.claustroSnp.modal.detalleErrorEnFechas').toString());
    } else if (this.claustroSeleccionado.profesorSnp?.claustroFechaBaja > today) {
      this.alertService().showError(this, this.$t('apeironGwApp.claustroSnp.modal.detalleErrorFechaBajaMayorActual').toString());
    } else {
      if (!this.readOnly) {
        this.participanteService()
          .update(this.claustroSeleccionado)
          .then(() => {
            this.mostrarModalEditar = false;
          })
          .catch(error => {
            this.alertService().showHttpError(this, error.response);
          })
          .finally(() => {
            this.obtenerProfesores();
          });
      } else {
        this.mostrarModalEditar = false;
      }
    }
  }

  public eliminarClaustro(): void {
    if (!this.readOnly) {
      this.participanteService()
        .delete(this.claustroSeleccionado.id)
        .then(() => {
          this.mostrarModalEliminar = false;
        })
        .catch(error => {
          this.alertService().showHttpError(this, error.response);
        })
        .finally(() => {
          this.obtenerProfesores();
        });
    } else {
      this.mostrarModalEliminar = false;
    }
  }

  public mostrarModalEditarClaustro(claustro: ParticipacionSnp): void {
    this.mostrarModalEditar = true;
    this.claustroSeleccionado = JSON.parse(JSON.stringify(claustro));
  }

  public mostrarModalDetalleClaustro(claustro: ParticipacionSnp): void {
    this.mostrarModalDetalle = true;
    this.claustroSeleccionado = claustro;
    this.buscarNivelSni();
  }

  private buscarNivelSni(): void {
    this.historicoPersonasApi()
      .getExpediente(this.claustroSeleccionado.participante.cvu)
      .then(res => {
        const vigencia = (res.data?.vigenciasSni ?? []).find(
          vig =>
            vig.activo &&
            !!vig.vigencia &&
            dayjs(new Date()).isAfter(vig.vigencia.fechaInicio) &&
            dayjs(new Date()).isBefore(vig.vigencia.fechaFin)
        );
        if (vigencia) {
          this.noSNIMessage = '';
          this.$set(this.claustroSeleccionado.profesorSnp, 'areaConocimientoId', vigencia.areaConocimientoEval?.id);
          this.$set(this.claustroSeleccionado.profesorSnp, 'areaConocimientoNombre', vigencia.areaConocimientoEval?.descripcion);
          this.$set(this.claustroSeleccionado.profesorSnp, 'vigenciaEstatus', vigencia.estatusVigencia?.descripcion);
          this.$set(this.claustroSeleccionado.profesorSnp, 'vigenciaFechaFin', new Date(vigencia.vigencia?.fechaFin));
          this.$set(this.claustroSeleccionado.profesorSnp, 'vigenciaFechaInicio', new Date(vigencia.vigencia?.fechaInicio));
          this.$set(this.claustroSeleccionado.profesorSnp, 'nivelSniClave', vigencia.nivelSni?.clave);
          this.$set(this.claustroSeleccionado.profesorSnp, 'nivelSniNombre', vigencia.nivelSni?.descripcion);
          this.$set(this.claustroSeleccionado.profesorSnp, 'vigenciaTipo', vigencia.tipo?.descripcion);
        } else {
          this.noSNIMessage = 'No se encontró nivel SNI';
        }
      })
      .catch(error => {
        if (error.response?.data?.status === StatusCodes.NOT_FOUND) {
          this.alertService().showWarning(this, this.$t('apeironGwApp.expediente.noResultado', 'Falla').toString());
        } else {
          this.alertService().showError(this, this.$t('apeironGwApp.expediente.noCarga', 'Falla').toString());
        }
      });
  }

  public cambiarPagina(pagina) {
    this.currentPage = pagina;
    this.obtenerProfesores();
  }

  public buscarDesdePrimerPagina() {
    this.currentPage = 1;
    this.obtenerProfesores();
  }

  public obtenerProfesores(): void {
    const filtroPart: FiltroParticipacion = {
      solicitudId: this.solicitud.id,
      rol: RolAutoridad.PROFESOR,
      like: this.filtroClaustro,
    };

    const paginationQuery = {
      page: this.currentPage - 1,
      size: this.perPage,
      sort: ['participante.nombre,asc', 'participante.apellidoPaterno,asc', 'participante.apellidoMaterno,asc'],
      filter: filtroPart,
    };
    this.participanteService()
      .obtenerParticipaciones(paginationQuery)
      .then(
        res => {
          this.claustros = [];
          res.data.forEach(item => {
            this.claustros.push(ParticipacionSnp.fromObject(item));
          });

          this.registros = Number(res.headers['x-total-count']);
        },
        err => {
          if (err.response.data.status !== StatusCodes.NOT_FOUND) {
            this.alertService().showHttpError(this, err.response);
          }
        }
      );
  }

  public reiniciarFiltros(): void {
    this.filtroClaustro = '';
  }

  get tiempoDedicacionInfo(): string {
    return this.claustroSeleccionado?.profesorSnp?.tiempoDedicacion?.nombre;
  }

  get institucionInfo(): string {
    return this.claustroSeleccionado?.profesorSnp?.institucion?.nombreInstitucion;
  }

  get sedeInfo(): string {
    return this.claustroSeleccionado?.profesorSnp?.sede?.sede + ' | ' + this.claustroSeleccionado?.profesorSnp?.sede?.nombreDependencia;
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado);
  }

  public reiniciaCampoFechaBaja(): void {
    this.claustroSeleccionado.profesorSnp.claustroFechaBaja = undefined;
  }
}
